import api from "@/services/api.service";
import readXlsxFile from 'read-excel-file'
import { required } from "vuelidate/lib/validators";

export default {
    name: 'add',
    components: {readXlsxFile},
    props: {},
    data() {
        return {
            caption: "Add Duplicate Mass Import",
            campaign_form: true,
            mapping_form: false,
            operators: [],
            showField: true,
            formField: {header_data: {}, xls_file: '',title : '',tags:[]},
            headers: [],
            head: [],
            map_headers: [],
            file: '',
            submitStatus: null,
            existing_tags: [] ,
            selectedHeaders : [],
            permission_add: false,
            superAdmin: false         
        }
    },
    computed: {},
    validations: {
        formField: {
          title: {
            required
        },        
        tags: {
            required
        }
    }
},
async created() {
    let response = await api.post("users/user-permissions");
        const permissions = [];
        if (response.status == "success") {
          response.data[0].permission.forEach( function(element) {                
              permissions.push(element.action)
          }.bind(this));
            if(permissions.includes("add_duplicate_mass_import_contact") == true){
                this.getTags();    
                this.permission_add = permissions.includes("add_duplicate_mass_import_contact");
            }else if(response.data[0].role == 'super_admin'){
                this.getTags();    
                this.superAdmin = true;
            }else if(permissions.includes("list_duplicate_mass_import_contact") == true || permissions.includes("add_duplicate_mass_import_contact") == true){
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Duplicate Mass Import List'});
            }else{
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Admin Dashboard'});
            }
        }     
},
mounted() {

},
methods: {
    makeToast(message = '', title = 'Alert', variant = 'warning', time = '3000') {
        this.toastCount++
        this.$root.$bvToast.toast(message, {
            title: title,
            variant: variant,
            autoHideDelay: time
        })
    },
    async getTags() {
      let response = await api.post("tags/list");
      if (!response)
        this.makeToast(
          "Something went to wrong please try again",
          "Alert",
          "danger",
          6000
          );
    if (response.status == "success") {
        response.data.forEach(
          function(e) {
            this.existing_tags.push({ key: e.tags, value: e.tags });
        }.bind(this)
        );
    }
},
headerSelect(e,index) {
      this.selectedHeaders[index] = e;      
      this.map_headers.forEach( function(header) {
        header.disabled = false;
        this.selectedHeaders.forEach(function(element) {   
          if(header.value == element)
            header.disabled = true;
        });
      }.bind(this));
    },
async showMappedForm() {
    if (!this.formField.title) {
        this.makeToast(`Plase enter title.`, 'Alert', 'danger')
        // return;
    }
    if (!this.formField.xls_file) {
        this.makeToast(`File is not uploaded.`, 'Alert', 'danger')
        return;
    }
    this.campaign_form = false;
    this.mapping_form = true;
    
    this.head = this.headers.map((h) => {
        return {name: h, 'value': ''}
    });
    let response = await api.post('admin/mapping_headers/list');
    if (!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)


    if (response.status == 'success') {
        if (response.data != '') {
            for (var key in response.data.data) {
                this.map_headers.push({value: response.data.data[key].column_key, text: response.data.data[key].column,disabled: false})
            }
        } else {
            this.map_headers = [];
            this.makeToast(`No database headers found.`, 'Alert', 'danger')
        }
    } else
    this.makeToast(`No database headers found.`, 'Alert', 'danger')


},
async save() {
    if (this.head) {
        this.formField.map_headers = this.head;
        this.formField.campaign_id = this.$route.params.id;
        let response = await api.post('admin/duplicate-mass-import/add', this.formField);
        if (!response)
            this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

        if (response.status == 'success') {            
            this.makeToast(response.message, 'Success', 'success')
            this.$router.push({'name': 'Duplicate Mass Import List'})
        } else {
            for (var error in response.errors)
                this.makeToast(response.errors[error], 'Alert', 'danger', 6000)
        }
    } else {
        this.makeToast(`Header not mapped ,please try again.`, 'Alert', 'danger')
        return false;
    }
},
onFileChanged(e) {
  let file = e.target.files[0];
  let reader = new FileReader();
console.log(file);
  /*if (file.type !=="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
    this.makeToast("File must  be xlsx", "Alert", "danger");
    return;
}*/
reader.onload = e => {
    let decode = e.target.result;
    readXlsxFile(decode).then(rows => {
      this.headers = rows[0];          
  },this.headers);

    this.formField.xls_file = btoa(decode);
};
reader.readAsBinaryString(file);
},
}
}

